<template>
  <v-row>
    <v-row>
      <v-col class="align-left">
        <ExpandCollapseToggle
          id="ratingsPanelToggle"
          @toggleAllPanels="toggleAllPanels"
          styleClass="mt-3"
          :panel="panel"
        />
      </v-col>
      <v-col class="align-right mt-2">
        <ValidationCountsHeader v-if="moduleType == MODULE_TYPES.MANAGEMENT" />
      </v-col>
    </v-row>
    <v-expansion-panels v-model="panel" multiple color="#fff">
      <v-expansion-panel style="margin-top: 20px" value="inspectionStatus">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('inspectionStatus')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Inspection Status</h3>
        </v-expansion-panel-title>

        <v-expansion-panel-text>
          <v-form v-model="validInspectionStatus" ref="inspectionStatusForm">
            <v-row>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelSm="6"
                  selectXl="8"
                  selectLg="8"
                  selectMd="6"
                  selectSm="6"
                  id="inspectionStatus"
                  label="IE.34 Inspection Status"
                  :refTable="REFERENCE_TABLE.INSPECTION_STATUS"
                  :isEditable="isEditable && moduleType != MODULE_TYPES.INSPECTION"
                  isRequired
                  v-model="ratingsValue.INSPSTAT"
                  @update:modelValue="checkIfNewlyAcceptedInspection()"
                ></LabelSelect>
              </v-col>
              <v-col cols="12" lg="6" xl="6" v-if="moduleType == MODULE_TYPES.MANAGEMENT">
                <LabelText
                  labelXl="4"
                  labelLg="4"
                  labelMd="6"
                  labelSm="6"
                  textXl="8"
                  textLg="8"
                  textMd="6"
                  textSm="6"
                  id="text_Inspection_Reviewer"
                  label="IE.35 Inspection Reviewer"
                  v-model="inspectionReviewer"
                >
                </LabelText>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="keyFields">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('keyFields')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Key Field Comparison since Last Accepted Inspection</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text>
          <FieldComparison ref="childFieldComparison" :moduleType="fieldComparisonModuleMode"> </FieldComparison>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="conditionRatings">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('conditionRatings')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Condition Ratings</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="validConditionRatings" ref="conditionRatingsForm">
            <v-row>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.dkRatingDuration, ratingsValue.dkRatingDurationChanges)"
                  @update:modelValue="
                    {
                      deckConditionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="deck"
                  label="B.C.01 Deck"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.DKRATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.supRatingDuration, ratingsValue.supRatingDurationChanges)"
                  @update:modelValue="
                    {
                      superstructureConditionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="superStructure"
                  label="B.C.02 Superstructure"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.SUPRATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.subRatingDuration, ratingsValue.subRatingDurationChanges)"
                  @update:modelValue="
                    {
                      substructureConditionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="substructure"
                  label="B.C.03 Substructure"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.SUBRATING"
                ></LabelSelect>
              </v-col>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.chanRatingDuration, ratingsValue.chanRatingDurationChanges)"
                  @update:modelValue="
                    {
                      channelConditionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="channel"
                  label="B.C.09 Channel"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.CHANRATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="channelProt"
                  label="B.C.10 Channel Protection"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.CHAN_PROT_RATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="scourCond"
                  label="B.C.11 Scour"
                  :refTable="REFERENCE_TABLE.SCOUR_CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="overallScourHole"
                  @update:modelValue="inspectionStore.setOverallScourHoleChangedByUser(true)"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.culvRatingDuration, ratingsValue.culvRatingDurationChanges)"
                  @update:modelValue="
                    {
                      culvertConditionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="culvert"
                  label="B.C.04 Culvert"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.CULVRATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="bearingRating"
                  label="B.C.07 Bearings"
                  :refTable="REFERENCE_TABLE.BEARING_CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.OVERALL_BEARINGS_RATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="jointRating"
                  label="B.C.08 Joints"
                  :refTable="REFERENCE_TABLE.JOINT_CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.OVERALL_JOINTS_RATING"
                ></LabelSelect>
              </v-col>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="lowestConditionRating"
                  label="B.C.13 Lowest Condition Rating"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  v-model="ratingsValue.LOWEST_CONDITION_RATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="nstmInspectionCondition"
                  label="B.C.14 NSTM Inspection Condition"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="nstmInspectionCondition"
                  @update:modelValue="inspectionStore.setNstmInspectionConditionChangedByUser(true)"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="waterway"
                  label="B.C.15 Underwater"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.UNDERWATER_RATING"
                ></LabelSelect>
              </v-col>
            </v-row>
            <v-row>
              <v-col sm="12">
                <LabelText
                  labelXl="12"
                  labelLg="12"
                  labelMd="12"
                  labelSm="12"
                  textXl="12"
                  textLg="12"
                  textMd="12"
                  textSm="12"
                  id="text_Inspection_Notes"
                  label="IE.36 Inspection Notes"
                  :isEditable="isEditable"
                  v-model="ratingsValue.INSPECTION_NOTES"
                  :maxlength="notesMaxLength"
                  type="textarea"
                  counter
                  persistentCounter
                  class="pb-0"
                >
                </LabelText>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="appraisalRatings">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('appraisalRatings')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Appraisal Ratings</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-form v-model="validAppraisalRatings" ref="appraisalRatingsForm">
            <v-row>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.railRatingDuration, ratingsValue.railRatingDurationChanges)"
                  @update:modelValue="
                    {
                      approachRailingUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="railing"
                  label="B.C.05 Railing"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.RAILRATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.transRatingDuration, ratingsValue.transRatingDurationChanges)"
                  @update:modelValue="
                    {
                      approachTransitionUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="transition"
                  label="B.C.06 Transition"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.TRANSRATIN"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="pierProt"
                  label="B.N.06 Substructure Navigation Protection"
                  :refTable="REFERENCE_TABLE.PIER_PROTECTION"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.PIER_PROTECTION"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="scourVulnerability"
                  label="B.AP.03 Scour Vulnerability"
                  :refTable="REFERENCE_TABLE.SCOUR_VULNERABILITY"
                  :isEditable="false"
                  isRequired
                  v-model="ratingsValue.SCOUR_VULNERABILITY"
                ></LabelSelect>
                <LabelCheckbox
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  id="newCoating"
                  class="labelCheckbox"
                  label="SUP.02 New Protective Coating?"
                  :showColon="false"
                  editIndent
                  :isEditable="isEditable"
                  v-model="ratingsValue.NEW_PAINT"
                >
                </LabelCheckbox>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(ratingsValue.paintCondRateDuration, ratingsValue.paintCondRateDurationChanges)
                  "
                  @update:modelValue="
                    {
                      protectiveCoatingUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="protectiveCoatings"
                  label="SUP.03 Protective Coating"
                  :refTable="REFERENCE_TABLE.PAINT_CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.PAINT_COND_RATE"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(ratingsValue.paintExtentRateDuration, ratingsValue.paintExtentRateDurationChanges)
                  "
                  @update:modelValue="
                    {
                      protectiveCoatingExtentUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="protectiveCoatingExtents"
                  label="SUP.04 Protective Coating (Extent)"
                  :refTable="REFERENCE_TABLE.PAINT_CONDITION_RATING_EXTENT"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.PAINT_EXTENT_RATING"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="select_Seismic_Vulnerability"
                  :isEditable="isEditable"
                  isRequired
                  label="B.AP.05 Seismic Vulnerability"
                  :refTable="REFERENCE_TABLE.SEISMIC_VULNERABILITY"
                  v-model="seismicVulnerability"
                  @update:modelValue="inspectionStore.setSeismicVulnerabilityChangedByUser(true)"
                ></LabelSelect>
              </v-col>
              <v-col cols="12" lg="6" xl="6">
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.apprAlignDuration, ratingsValue.apprAlignDurationChanges)"
                  @update:modelValue="
                    {
                      approachAlignmentUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="approachAlignments"
                  label="B.AP.01 Approach Rdwy Alignment"
                  :refTable="REFERENCE_TABLE.BRIDGE_CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.APPRALIGN"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(ratingsValue.apprSlabCondRateDuration, ratingsValue.apprSlabCondRateDurationChanges)
                  "
                  @update:modelValue="
                    {
                      approachSlabUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="approachSlabs"
                  label="AP.02 Approach Slab"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.APPR_SLAB_COND_RATE"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(ratingsValue.apprRoadCondRateDuration, ratingsValue.apprRoadCondRateDurationChanges)
                  "
                  @update:modelValue="
                    {
                      approachRoadwayUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="approachRoadways"
                  label="AP.01 Approach Roadway"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.APPR_ROAD_COND_RATE"
                ></LabelSelect>
                <LabelSelect
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(ratingsValue.deckWsCondRateDuration, ratingsValue.deckWsCondRateDurationChanges)
                  "
                  @update:modelValue="
                    {
                      deckWearingSurfaceUpdated = true;
                      conditionUpdated = true;
                    }
                  "
                  id="deckWearingSurfaces"
                  label="DK.01 Deck Wearing Surface"
                  :refTable="REFERENCE_TABLE.CONDITION_RATING"
                  :isEditable="isEditable"
                  isRequired
                  v-model="ratingsValue.DECK_WS_COND_RATE"
                ></LabelSelect>
                <LabelSelect
                  :class="isEditable ? 'py-1' : ''"
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="scbi"
                  :isEditable="false"
                  label="WA.01 SCBI"
                  showDurationIcon
                  :tooltip="
                    getHistDuration(ratingsValue.scourCriticalDuration, ratingsValue.scourCriticalDurationChanges)
                  "
                  :refTable="REFERENCE_TABLE.SCOUR_CRITICAL_BRIDGE_INDICATOR"
                  v-model="ratingsValue.SCOURCRIT"
                ></LabelSelect>
                <LabelText
                  :class="isEditable ? 'py-1' : ''"
                  :labelXl="5"
                  :labelLg="5"
                  :labelMd="6"
                  :labelSm="6"
                  :textXl="6"
                  :textLg="5"
                  :textMd="4"
                  :textSm="3"
                  id="scbiCat"
                  :isEditable="false"
                  label="WA.02 SCBI Category"
                  v-model="ratingsValue.SCOUR_CRIT_CTGRY"
                ></LabelText>
                <LabelSelect
                  :class="isEditable ? 'py-1' : ''"
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="bridgeCondition"
                  :isEditable="false"
                  label="B.C.12 Bridge Condition"
                  showDurationIcon
                  :tooltip="getHistDuration(ratingsValue.conditionDuration)"
                  :refTable="REFERENCE_TABLE.BRIDGE_CONDITION_RATING"
                  v-model="ratingsValue.BRIDGE_CONDITION_RATING"
                ></LabelSelect>
                <LabelSelect
                  :class="isEditable ? 'py-1' : ''"
                  labelXl="5"
                  labelLg="5"
                  labelMd="6"
                  labelSm="6"
                  selectXl="6"
                  selectLg="6"
                  selectMd="6"
                  selectSm="6"
                  id="deficiencyScore"
                  :isEditable="false"
                  label="M.28 Deficiency Score"
                  v-model="ratingsValue.MAINT_DEF_RATE"
                ></LabelSelect>
              </v-col>
            </v-row>
          </v-form>
        </v-expansion-panel-text>
      </v-expansion-panel>
      <v-expansion-panel value="workflow" v-if="moduleType === MODULE_TYPES.MANAGEMENT">
        <v-expansion-panel-title
          class="d-flex justify-start"
          hide-actions
          expand-icon="fa-solid fa-plus"
          collapse-icon="fa-solid fa-minus"
        >
          <v-icon v-if="panel.includes('workflow')" icon="fa-solid fa-minus" />
          <v-icon v-else icon="fa-solid fa-plus" />
          <h3>Workflow</h3>
        </v-expansion-panel-title>
        <v-expansion-panel-text eager>
          <v-data-table
            :headers="RatingWorkflowTableHeader"
            :items="ratingsValue.inspectionStatusAudits"
            :items-per-page="-1"
            hide-default-footer
            v-model:sort-by="sortBy"
          >
            <template v-slot:[`header.changedInspStatus`]="{ column }">
              <DataTableHeader :sortBy="sortBy" :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.updateUserId`]="{ column }">
              <DataTableHeader :sortBy="sortBy" :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.newInspStatus`]="{ column }">
              <DataTableHeader :sortBy="sortBy" :column="column" :lines="2" />
            </template>
            <template v-slot:[`header.updateDateTime`]="{ column }">
              <DataTableHeader :sortBy="sortBy" :column="column" :lines="2" />
            </template>
            <template v-slot:item="{ item }">
              <tr style="word-break: break-word">
                <td class="alignCenter">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.INSPECTION_STATUS, item.changedInspStatus) }}
                </td>
                <td class="alignCenter">
                  {{ getUserName(item.updateUserId) }}
                </td>
                <td class="alignCenter">
                  {{ configStore.getReferenceValue(REFERENCE_TABLE.INSPECTION_STATUS, item.newInspStatus) }}
                </td>
                <td class="alignCenter">
                  {{ formatDateTime12Hour(new Date(item.updateDateTime)) }}
                </td>
              </tr>
            </template>
          </v-data-table>
        </v-expansion-panel-text>
      </v-expansion-panel>
    </v-expansion-panels>
    <ValidationResponse
      :show="showValidation"
      :validationErrors="getValidations"
      :isRatingsAcceptanceValidation="true"
      :brkey="ratingsValue.BRKEY"
      :inspectionId="ratingsValue.INSPECTIONID"
      :submissionInspectionComments="ratingsValue.submissionInspectionComments"
      :previousSubmissionInspectionComments="ratingsValue.previousSubmissionInspectionComments"
      @close="showValidation = false"
      @handleSaveWithExceptions="
        (submissionInspectionComments) => handleSaveWithExceptions(submissionInspectionComments)
      "
    ></ValidationResponse>
  </v-row>
</template>

<script>
import { computed, ref, watch, onMounted } from "vue";
import { useConfigStore } from "@/stores/config";
import { useInspectionStore } from "@/stores/inspection";
import { REFERENCE_TABLE } from "@/constants/ReferenceTables";
import { getHistDuration } from "@/composables/util";
import LabelSelect from "@/components/common/LabelSelect.vue";
import LabelCheckbox from "@/components/common/LabelCheckbox.vue";
import LabelText from "@/components/common/LabelText.vue";
import { ENV_CONFIG_PROPERTY } from "@/constants/EnvConfigProperties";
import FieldComparison from "@/components/shared/FieldComparison.vue";
import ExpandCollapseToggle from "@/components/shared/ExpandCollapseToggle.vue";
import { MODULE_TYPES } from "@/constants/InspectionConstants";
import { useRatingsStore } from "@/components/inspection/store/ratings";
import { useQuickSearchStore } from "@/stores/quickSearch";
import { storeToRefs } from "pinia";
import { useUserPermissionStore } from "@/stores/userPermission";
import { INSPECTION_LINKS_RATINGS_PERMISSIONS } from "@/rbac";
import { ACCESS_LEVELS } from "@/rbac/accessLevels.js";
import { useInspectionLinksStore } from "@/stores/inspectionLinks";
import { INSPECTION_STATUSES } from "@/constants/InspectionStatuses";
import { SNACKBAR_MARKER } from "@/constants/GlobalSnackbar";
import ValidationCountsHeader from "@/components/shared/ValidationCountsHeader.vue";
import DataTableHeader from "@/components/common/DataTableHeader.vue";
import { RatingWorkflowTableHeader } from "@/constants/WorkflowTable";
import { formatDateTime12Hour } from "@/composables/dateField.js";
import ValidationResponse from "@/components/shared/ValidationResponse.vue";

export default {
  name: "InspectionRatings",
  props: {
    moduleType: { default: MODULE_TYPES.INSPECTION },
  },
  emits: ["saveWithExceptions"],
  setup(props, ctx) {
    const configStore = useConfigStore();
    const inspectionStore = useInspectionStore();
    const ratingsStore = useRatingsStore();
    const quickSearchStore = useQuickSearchStore();
    const structureHeader = computed(() => quickSearchStore.getStructure());
    const { hasQuickSearchSucceeded } = storeToRefs(quickSearchStore);
    const userPermissionStore = useUserPermissionStore();
    const inspectionLinksStore = useInspectionLinksStore();
    const childFieldComparison = ref(null);

    let ratingsValue = ref({});

    let resetDirty = ref(false);
    const isEditable = computed(() => {
      if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
        return hasQuickSearchSucceeded.value && ratingsValue?.value?.BRKEY && hasAccessToEdit.value;
      } else {
        return inspectionStore.isEditable;
      }
    });

    const sortBy = ref([{ key: "updateDateTime", order: "desc" }]);

    const fieldComparisonModuleMode = computed(() => {
      return props.moduleType;
    });

    const hasAccessToEdit = computed({
      get() {
        if (structureHeader.value?.INSPECTIONSTATUS === INSPECTION_STATUSES.ACCEPTED) {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_RATINGS_PERMISSIONS[ACCESS_LEVELS.CUSTOM.EDIT_APPROVED_INSPECTION],
            userPermissionStore.getUserPermissionByBrkeyFromCache(ratingsValue.value.BRKEY),
          );
        } else {
          return userPermissionStore.checkUserPermission(
            INSPECTION_LINKS_RATINGS_PERMISSIONS[ACCESS_LEVELS.EDIT],
            userPermissionStore.getUserPermissionByBrkeyFromCache(ratingsValue.value.BRKEY),
          );
        }
      },
    });

    const inspectionReviewer = computed(() => {
      return configStore.getUserDisplayNameByUserId(ratingsValue.value.inspectionReviewer);
    });

    const getValidations = computed(() => {
      return ratingsStore?.validations;
    });

    const getFailures = computed(() => {
      return ratingsStore?.validations?.some((e) => e.severity == "1");
    });

    const getErrors = computed(() => {
      return ratingsStore?.validations?.some((e) => e.severity == "2");
    });

    const getWarnings = computed(() => {
      return ratingsStore?.validations?.some((e) => e.severity == "3");
    });

    let structure = computed(() => inspectionStore.selectedInspection);
    const allPanels = ["inspectionStatus", "keyFields", "conditionRatings", "appraisalRatings", "workflow"];
    const panel = ref(allPanels);
    let validConditionRatings = ref(true);
    let validAppraisalRatings = ref(true);
    let validInspectionStatus = ref(true);
    let valid = ref(true);
    let conditionRatingsForm = ref(null);
    let appraisalRatingsForm = ref(null);
    let inspectionStatusForm = ref(null);
    let showValidation = ref(false);

    const readData = async () => {
      resetChangedByUser();
      ratingsValue.value = {};
      resetDirty.value = true;
      if (props.moduleType == MODULE_TYPES.MANAGEMENT && structureHeader.value?.BRKEY) {
        await ratingsStore.loadDataObject(
          props.moduleType,
          structureHeader.value.BRKEY,
          structureHeader.value.INSPECTIONID,
        );
        ratingsValue.value = ratingsStore.getRatingsObject();
      } else if (props.moduleType == MODULE_TYPES.INSPECTION) {
        await ratingsStore.loadDataObject(props.moduleType, null, null, structure.value);
        ratingsValue.value = ratingsStore.getRatingsObject();
      } else {
        return;
      }
      resetDirty.value = true;
      await childFieldComparison?.value?.readData();
      handleKeyFieldExpansion();
      await validate();
    };

    async function validate() {
      await inspectionStatusForm.value.validate();
      await conditionRatingsForm.value.validate();
      await appraisalRatingsForm.value.validate();
      if (validInspectionStatus.value && validConditionRatings.value && validAppraisalRatings.value) {
        valid.value = true;
      } else {
        valid.value = false;
      }
    }

    if (!isEditable.value) {
      panel.value = allPanels;
    }
    onMounted(async () => {
      await readData();
    });
    let seismicVulnerabilityChangedByUser = ref(false);

    const seismicVulnerability = computed({
      get() {
        if (!ratingsValue.value.SEISMIC_VULNERABILITY && !inspectionStore.getSeismicVulnerabilityChangedByUser) {
          return "0";
        } else {
          return ratingsValue.value.SEISMIC_VULNERABILITY;
        }
      },
      set(seismicVulnerabilityParam) {
        ratingsValue.value.SEISMIC_VULNERABILITY = seismicVulnerabilityParam;
        inspectionStore.setSeismicVulnerabilityChangedByUser(true);
      },
    });

    const overallScourHole = computed({
      get() {
        if (props.moduleType == MODULE_TYPES.MANAGEMENT) {
          return inspectionStore.getOverallScourHole(
            ratingsValue.value.SCOUR_COND_RATING,
            ratingsValue.value.SCOUR_HOLE,
            null,
          );
        } else {
          return inspectionStore.getOverallScourHole(ratingsValue.value.SCOUR_COND_RATING, null, structure.value);
        }
      },
      set(overallScourParam) {
        ratingsValue.value.SCOUR_COND_RATING = overallScourParam;
      },
    });

    const hasValidationPassedForAcceptance = computed(() => {
      return !getFailures.value && ((!getErrors.value && !getWarnings.value) || ratingsStore.savedWithExceptions);
    });

    const resetChangedByUser = async () => {
      inspectionStore.setNstmInspectionConditionChangedByUser(false);
      inspectionStore.setSeismicVulnerabilityChangedByUser(false);
      inspectionStore.setOverallScourHoleChangedByUser(false);
    };

    const notesMaxLength = computed(() => {
      return configStore.getEnvConfigValue(ENV_CONFIG_PROPERTY.STRUCTURE_NOTES_MAX_LENGTH);
    });

    let deckConditionUpdated = ref(false);
    let superstructureConditionUpdated = ref(false);
    let substructureConditionUpdated = ref(false);
    let channelConditionUpdated = ref(false);
    let culvertConditionUpdated = ref(false);
    let conditionUpdated = ref(false);

    const updateConditionRatings = () => {
      if (!ratingsValue.value.inspectionConditionHist) {
        ratingsValue.value.inspectionConditionHist = {};
      }
      if (deckConditionUpdated.value) {
        ratingsValue.value.dkRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.dkRatingDurationChanges,
        );
        ratingsValue.value.dkRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.dkRatingDuration,
          ratingsValue.value.dkRatingDurationChanges,
        );
      }
      if (superstructureConditionUpdated.value) {
        ratingsValue.value.supRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.supRatingDurationChanges,
        );
        ratingsValue.value.supRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.supRatingDuration,
          ratingsValue.value.supRatingDurationChanges,
        );
      }
      if (substructureConditionUpdated.value) {
        ratingsValue.value.subRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.subRatingDurationChanges,
        );
        ratingsValue.value.subRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.subRatingDuration,
          ratingsValue.value.subRatingDurationChanges,
        );
      }
      if (channelConditionUpdated.value) {
        ratingsValue.value.chanRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.chanRatingDurationChanges,
        );
        ratingsValue.value.chanRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.chanRatingDuration,
          ratingsValue.value.chanRatingDurationChanges,
        );
      }
      if (culvertConditionUpdated.value) {
        ratingsValue.value.culvRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.culvRatingDurationChanges,
        );
        ratingsValue.value.culvRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.culvRatingDuration,
          ratingsValue.value.culvRatingDurationChanges,
        );
      }
      deckConditionUpdated.value = false;
      superstructureConditionUpdated.value = false;
      substructureConditionUpdated.value = false;
      channelConditionUpdated.value = false;
      culvertConditionUpdated.value = false;
    };

    let approachAlignmentUpdated = ref(false);
    let approachRoadwayUpdated = ref(false);
    let approachSlabUpdated = ref(false);
    let approachRailingUpdated = ref(false);
    let approachTransitionUpdated = ref(false);

    let protectiveCoatingUpdated = ref(false);

    let deckWearingSurfaceUpdated = ref(false);

    let protectiveCoatingExtentUpdated = ref(false);

    const saveConditionFields = async () => {
      ratingsValue.value.NSTM_CONDITION = nstmInspectionCondition.value;
    };

    const checkIfNewlyAcceptedInspection = () => {
      if (ratingsValue.value.INSPSTAT == "9" && ratingsStore.originalInspectionsStatus != "9") {
        ratingsValue.value.newlyAcceptedInspection = true;
      }
    };

    function getNSTMInspectionCondition() {
      if (ratingsValue.value?.MAIN_FC_GROUP_NUM < 5 || ratingsValue.value?.APPR_FC_GROUP_NUM < 5) {
        return ratingsValue.value?.SUPRATING;
      } else {
        return "N";
      }
    }

    const nstmInspectionConditionChangedByUser = computed(
      () => inspectionStore.getNstmInspectionConditionChangedByUser,
    );

    const nstmInspectionCondition = computed({
      get() {
        if (!ratingsValue.value.NSTM_CONDITION && !nstmInspectionConditionChangedByUser.value) {
          return getNSTMInspectionCondition();
        } else {
          return ratingsValue.value.NSTM_CONDITION;
        }
      },
      set(inspectionConditionParam) {
        ratingsValue.value.NSTM_CONDITION = inspectionConditionParam;
      },
    });

    const getUserName = computed(() => (userId) => {
      return /^\d+$/.test(userId)
        ? configStore.getUserDisplayNameByUserId(userId)
        : configStore.getUserNameByUserLogin(userId);
    });

    const updateAppraisalRatings = () => {
      if (!ratingsValue.value.inspectionConditionHist) {
        ratingsValue.value.inspectionConditionHist = {};
      }
      if (approachAlignmentUpdated.value) {
        ratingsValue.value.apprAlignDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.apprAlignDurationChanges,
        );
        ratingsValue.value.apprAlignDuration = inspectionStore.setDuration(
          ratingsValue.value.apprAlignDuration,
          ratingsValue.value.apprAlignDurationChanges,
        );
      }
      if (approachRoadwayUpdated.value) {
        ratingsValue.value.apprRoadCondRateDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.apprRoadCondRateDurationChanges,
        );
        ratingsValue.value.apprRoadCondRateDuration = inspectionStore.setDuration(
          ratingsValue.value.apprRoadCondRateDuration,
          ratingsValue.value.apprRoadCondRateDurationChanges,
        );
      }
      if (approachSlabUpdated.value) {
        ratingsValue.value.apprSlabCondRateDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.apprSlabCondRateDurationChanges,
        );
        ratingsValue.value.apprSlabCondRateDuration = inspectionStore.setDuration(
          ratingsValue.value.apprSlabCondRateDuration,
          ratingsValue.value.apprSlabCondRateDurationChanges,
        );
      }
      if (approachRailingUpdated.value) {
        ratingsValue.value.railRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.railRatingDurationChanges,
        );
        ratingsValue.value.railRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.railRatingDuration,
          ratingsValue.value.railRatingDurationChanges,
        );
      }
      if (approachTransitionUpdated.value) {
        ratingsValue.value.transRatingDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.transRatingDurationChanges,
        );
        ratingsValue.value.transRatingDuration = inspectionStore.setDuration(
          ratingsValue.value.transRatingDuration,
          ratingsValue.value.transRatingDurationChanges,
        );
      }

      if (protectiveCoatingUpdated.value) {
        ratingsValue.value.paintCondRateDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.paintCondRateDurationChanges,
        );
        ratingsValue.value.paintCondRateDuration = inspectionStore.setDuration(
          ratingsValue.value.paintCondRateDuration,
          ratingsValue.value.paintCondRateDurationChanges,
        );
      }

      if (deckWearingSurfaceUpdated.value) {
        ratingsValue.value.deckWsCondRateDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.deckWsCondRateDurationChanges,
        );
        ratingsValue.value.deckWsCondRateDuration = inspectionStore.setDuration(
          ratingsValue.value.deckWsCondRateDuration,
          ratingsValue.value.deckWsCondRateDurationChanges,
        );
      }

      if (protectiveCoatingExtentUpdated.value) {
        ratingsValue.value.paintExtentRateDurationChanges = inspectionStore.setDurationChanges(
          ratingsValue.value.paintExtentRateDurationChanges,
        );
        ratingsValue.value.paintExtentRateDuration = inspectionStore.setDuration(
          ratingsValue.value.paintExtentRateDuration,
          ratingsValue.value.paintExtentRateDurationChanges,
        );
      }

      protectiveCoatingUpdated.value = false;

      deckWearingSurfaceUpdated.value = false;

      protectiveCoatingExtentUpdated.value = false;
      approachTransitionUpdated.value = false;
      approachAlignmentUpdated.value = false;
      approachRailingUpdated.value = false;
      approachRoadwayUpdated.value = false;
      approachSlabUpdated.value = false;
    };
    const updateDuration = () => {
      updateConditionRatings();
      updateAppraisalRatings();
      conditionUpdated.value = false;
    };
    const toggleAllPanels = (expandAll) => {
      if (expandAll) {
        panel.value = allPanels;
      } else {
        panel.value = [];
      }
    };

    const handleKeyFieldExpansion = () => {
      if (ratingsValue.value.INSPSTAT === "9") {
        panel.value = panel.value.filter((p) => p !== "keyFields");
      } else if (ratingsValue.value.INSPSTAT !== "9" && !panel.value.includes("keyFields")) {
        panel.value.push("keyFields");
      }
    };

    const handleSaveWithExceptions = async (submissionInspectionComments) => {
      ratingsValue.value.submissionInspectionComments = submissionInspectionComments;
      showValidation.value = false;
      ratingsStore.savedWithExceptions = true;
      ctx.emit("saveWithExceptions");
    };

    const saveChanges = async () => {
      await validate();
      if (!valid.value) {
        return;
      }
      if (ratingsValue.value.newlyAcceptedInspection) {
        await ratingsStore.validateInspectionForRatingsAcceptance(
          ratingsValue.value.BRKEY,
          ratingsValue.value.INSPECTIONID,
        );
        if (!hasValidationPassedForAcceptance.value) {
          showValidation.value = true;
          return "Validation Failed For Acceptance";
        }
      }
      const isSuccess = await ratingsStore.saveData(props.moduleType, ratingsValue.value, structure.value);
      if (isSuccess) {
        if (props.moduleType == MODULE_TYPES.INSPECTION) {
          inspectionStore.setLowestConditionRating();
          await ratingsStore.loadDataObject(props.moduleType, null, null, structure.value);
        }
        await childFieldComparison?.value?.readData();
        ratingsValue.value = ratingsStore.getRatingsObject();
        structureHeader.value.INSPECTIONSTATUS = ratingsValue.value.INSPSTAT;
        // Using this flag to not set the dirty flag in watch
        resetDirty.value = true;
      }
      return isSuccess;
    };

    const cancelChanges = async () => {
      //only called from Inspection Links
      ratingsValue.value = ratingsStore.getRatingsObject();
      // Using this flag to not set the dirty flag in watch
      resetDirty.value = true;
      inspectionLinksStore.isDirty = false;
    };

    const printD491 = () => {
      return { reportPage: "D491-Insp-Ratings-Screen", marker: SNACKBAR_MARKER.RATINGS };
    };

    // watch those objects used in component from structure to warn about unsaved changes
    watch(
      () => [ratingsValue],
      () => {
        // This watch will NOT be triggered during initial onMounted()
        if (props.moduleType === MODULE_TYPES.MANAGEMENT) {
          // for management module
          if (resetDirty.value) {
            inspectionLinksStore.isDirty = false;
            resetDirty.value = false;
          } else {
            inspectionLinksStore.isDirty = true;
          }
        } else if (props.moduleType === MODULE_TYPES.INSPECTION) {
          // for inspection  module
          if (resetDirty.value) {
            inspectionStore.setDirtyFlag(false);
            resetDirty.value = false;
          } else {
            inspectionStore.setDirtyFlag(true);
          }
        }
      },
      { deep: true },
    );

    watch(
      () => [props],
      () => {
        readData();
      },
      { deep: true },
    );

    watch(hasQuickSearchSucceeded, (val) => {
      if (!val) resetDirty.value = true;
    });

    return {
      overallScourHole,
      sortBy,
      hasValidationPassedForAcceptance,
      checkIfNewlyAcceptedInspection,
      handleSaveWithExceptions,
      showValidation,
      getFailures,
      getValidations,
      getErrors,
      inspectionStore,
      protectiveCoatingExtentUpdated,
      deckWearingSurfaceUpdated,
      protectiveCoatingUpdated,
      approachSlabUpdated,
      approachTransitionUpdated,
      approachRailingUpdated,
      approachRoadwayUpdated,
      updateDuration,
      approachAlignmentUpdated,
      updateConditionRatings,
      culvertConditionUpdated,
      channelConditionUpdated,
      substructureConditionUpdated,
      superstructureConditionUpdated,
      deckConditionUpdated,
      conditionUpdated,
      resetChangedByUser,
      seismicVulnerabilityChangedByUser,
      seismicVulnerability,
      structure,
      REFERENCE_TABLE,
      getHistDuration,
      panel,
      isEditable,
      notesMaxLength,
      conditionRatingsForm,
      appraisalRatingsForm,
      validate,
      valid,
      validConditionRatings,
      validAppraisalRatings,
      toggleAllPanels,
      MODULE_TYPES,
      ratingsValue,
      readData,
      saveChanges,
      cancelChanges,
      fieldComparisonModuleMode,
      childFieldComparison,
      nstmInspectionCondition,
      saveConditionFields,
      printD491,
      validInspectionStatus,
      inspectionStatusForm,
      RatingWorkflowTableHeader,
      configStore,
      formatDateTime12Hour,
      inspectionReviewer,
      getUserName,
    };
  },
  components: {
    ValidationResponse,
    LabelSelect,
    LabelCheckbox,
    LabelText,
    FieldComparison,
    ExpandCollapseToggle,
    ValidationCountsHeader,
    DataTableHeader,
  },
};
</script>

<style scoped lang="scss">
@use "@/styles/colors" as c;

h3 {
  order: 1;
  color: c.$p-white !important;
}
</style>
